// extracted by mini-css-extract-plugin
export const layout = "layout-bloc-module--layout--2Qlas";